import { useQuery } from '@apollo/client';
import { Checkbox } from '@material-ui/core';
import { ReactComponent as CheckedIcon } from 'assets/svg/checkboxChecked.svg';
import { ReactComponent as SearchIcon } from 'assets/svg/search.svg';
import { ReactComponent as UnCheckedIcon } from 'assets/svg/unCheck.svg';
import UserType from 'constants/user';
import { cache } from 'graph_ql/index';
import { AlgoliaInput, AlgoliaResponse } from 'graph_ql/types/types';
import { GET_USERS } from 'graph_ql/users/queries';
import { IAlgoliaUser } from 'graph_ql/users/types';
import { debounce, get } from 'lodash';
import { useMemo, useRef, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import themes from 'styles/themes';
import { searchConsumerStyles } from './filter_consumer_style';
import { ALL_CONSUMER_OPTION } from './my_styles_screen';

const FilterConsumer = (props) => {
    const { selectedConsumer, setSelectedConsumer } = props;
    const [consumersList, setConsumerList] = useState<any>([]);
    const height: any = use100vh();

    const getUserVariables = useMemo(() => {
        cache.modify({
            fields: {
                algoliaGetUsers(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        return {
            query: selectedConsumer.valueSearch,
            filters: `userType:${UserType.Customer}`,
            page: 0,
            hit: 100,
        };
        // eslint-disable-next-line
    }, [selectedConsumer.valueSearch]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    useQuery<AlgoliaResponse<IAlgoliaUser, 'algoliaGetUsers'>, AlgoliaInput>(GET_USERS, {
        variables: getUserVariables,
        fetchPolicy: 'cache-first',
        onCompleted(res) {
            if (!res) return;
            if (get(res, ['algoliaGetUsers', 'hits'], []).length) {
                const data = res.algoliaGetUsers.hits.map((item) => {
                    return {
                        id: item.id,
                        fullName: `${item.firstName} ${item.lastName}`,
                    };
                });
                setConsumerList([ALL_CONSUMER_OPTION, ...data]);
            } else {
                setConsumerList([ALL_CONSUMER_OPTION]);
            }
        },
    });

    const classes = searchConsumerStyles();

    const debounceSearch = useRef(debounce((value) => {}, 300)).current;

    const onSearchCategory = (event) => {
        const value = event.target.value;
        setSelectedConsumer({
            ...selectedConsumer,
            valueSearch: value,
        });
        debounceSearch(value);
    };

    const onSelectConsumer = (e) => {
        setSelectedConsumer({
            ...selectedConsumer,
            selected: e,
        });
    };

    return (
        <div className={classes.sortWrap}>
            <div className={classes.searchWrap}>
                <input
                    className={classes.input}
                    type="text"
                    value={selectedConsumer.valueSearch}
                    onChange={onSearchCategory}
                    onKeyDown={onSearchCategory}
                    placeholder="Search"
                    style={{
                        caretColor: themes.palette.primary.main,
                    }}
                />
                <span style={{ position: 'absolute', left: 2, top: 0 }}>
                    <SearchIcon className={classes.searchIcon} />
                </span>
            </div>
            <div
                style={{
                    height: `${height - 250}px`,
                }}
                className={classes.selectedOption}
            >
                {consumersList &&
                    consumersList.map((item, index) => (
                        <div onClick={() => onSelectConsumer(item)} key={index} className={classes.selectedOptionItem}>
                            <Checkbox
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                                checked={item?.id === selectedConsumer?.selected?.id}
                                disableRipple={true}
                                checkedIcon={<CheckedIcon />}
                                icon={<UnCheckedIcon />}
                            />
                            <div className={classes.selectedOptionTitle}>{item.fullName}</div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default FilterConsumer;
